/** Delays at or below this many hundredths of a second get replaced by browsers. */
const MIN_BROWSER_DELAY = 1
/** What browsers play in their place: 100ms. */
const BROWSER_DEFAULT_DELAY = 10

/**
 * A GIF frame's delay in seconds, as browsers actually play it.
 *
 * GIF delays are stored in hundredths of a second, and plenty of GIFs are saved
 * with 0 or 1. Chrome, Firefox and Safari all play those as 10 (100ms), so
 * taking the stored value at face value makes the editor preview run up to ten
 * times faster than the same GIF plays anywhere else.
 */
export function gifFrameDelaySeconds(delay: number): number {
    return (delay <= MIN_BROWSER_DELAY ? BROWSER_DEFAULT_DELAY : delay) / 100
}
